/// <reference types="@angular/localize" />

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  window.console.log = () => { }
}

// 1. Configuración de Links (CSS y Fuentes)
const links = [
  {
    rel: 'stylesheet',
    href: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css',
    integrity: 'sha384-GLhlTQ8iRABdZLl6O3oVMWSktQOp6b7In1Zl3/Jr59b6EGGoI1aFkw7cmDA6j6gD'
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap',
    integrity: 'sha384-8PiN2bLaTIzO9Ez91KkeSIFNFdgLHWHOXgPVnspcDLcr368v7QJRY66E9huzqK7h'
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
    integrity: 'sha384-m9N6jCtM6G1HOYTiXrGvYc/XkdRvPhU/yaB4cAh8yHA74cfAE+joMhMl5Xi+85MA'
  }
];

// 3. Carga de Links
links.forEach(l => {
  const link = document.createElement('link');
  link.rel = l.rel;
  link.href = l.href;
  if (l.integrity) {
    link.integrity = l.integrity;
    link.setAttribute('crossorigin', 'anonymous');
  }
  document.head.appendChild(link);
});
// 4. Configuración unificada de Scripts
interface ScriptItem {
  src: string;
  integrity?: string;
  defer?: boolean;
  async?: boolean;
}

const scripts: ScriptItem[] = [
  {
    src: 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js',
    integrity: 'sha384-w76AqPfDkMBDXo30jS1Sgez6pr3x5MlQ1ZAGC+nuZB+EYdgRZgiwxhTBTkF7CXvN'
  },
  {
    src: 'https://cdn.jsdelivr.net/npm/leaflet@1.9.3/dist/leaflet.js',
    // integrity: 'sha384-mFode1dsCI6/6VjTqgm0QrCoXtE+3BGVsdJhPG1REOcGLxbcyIPbAjWcYfHG9EJK',
    defer: true
  }
];

// 5. Carga y ejecución de Scripts
scripts.forEach(s => {
  const script = document.createElement('script');
  script.src = s.src;

  if (s.integrity) {
    script.integrity = s.integrity;
    script.setAttribute('crossorigin', 'anonymous');
  }

  if (s.defer) script.defer = true;
  if (s.async !== undefined) script.async = s.async;

  document.head.appendChild(script);
});

// 6. Arranque de Angular de forma autónoma
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));